import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=4bb90af4&scoped=true&"
import script from "./Textfield.vue?vue&type=script&lang=js&"
export * from "./Textfield.vue?vue&type=script&lang=js&"
import style0 from "./Textfield.vue?vue&type=style&index=0&id=4bb90af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb90af4",
  null
  
)

export default component.exports